/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/
import React, { useCallback, useState } from 'react';
import { useIntl } from '@exo/frontend-common-i18n';
import { LayoutSpacing } from '@exo/frontend-components-core';
import { Address } from '@exo/frontend-components-commerce';
import {
  Cart,
  CartContainerRenderProps,
  useCartModification
} from '@exo/frontend-features-cart-logic';
import * as S from './CheckoutSidebar.styles';
// import { CartSummary } from '../CartSummary/CartSummary';
import {
  Button,
  Checkbox,
  Dropdown,
  TextInput as NumberInput
} from '@exo/frontend-components-base';
// import { ArrowRight16 } from '@carbon/icons-react';
import { useMediaQuery } from 'react-responsive';
import { PromoCode } from '@exo/frontend-features-cart-ui';
import { useNotificationContext } from '@exo/frontend-common-notification';
import { useSessionContext } from '@exo/frontend-common-session-context';
import { ErrorResponse } from '@apollo/client/link/error';
import { GraphQLError } from 'graphql';
import { useCheckoutContext } from '@exo/frontend-features-checkout-logic';
import { CartSubtotal } from '@exo/frontend-features-cart-ui';
import { useOrderHistory } from '@exo/frontend-features-account-profile-logic';
import { gql } from '@apollo/client';
import _ from 'lodash';

export const CheckoutSidebar = ({ cart, shippingAddress, billingAddress, addressShow }: Props) => {
  const { data }: any = useOrderHistory({}, CheckoutSidebar.fragment);
  const orders = data?.me?.orders?.edges;
  // console.log('chk data',data?.me?.orders?.edges)

  /* const intl = useIntl('features.checkout.checkout-ui.components.CheckoutSidebar'); */
  const isMobile = useMediaQuery({ query: '(max-width:576px)' });
  const [isGiftCard, setGiftCart] = useState(false);
  const [showGiftSec, setGiftSec] = useState(false);
  const [giftCardApplied, setGiftCardApplied] = useState(false);
  const [removingCard, setRemovingCard] = useState(false);
  const [GCNum, setGCNum] = useState('');
  const [ACode, setACode] = useState('');
  const cartApi = useCartModification();
  const { createNotification: notify } = useNotificationContext();
  const intl = useIntl('features.catalog.catalog-ui.pages.ProductDetailsPage');
  const session = useSessionContext();
  const { roles } = session;
  const isUser = roles[0] === 'user';
  const [errMsg, setErrMsg] = useState<any>('');
  const { checkout } = useCheckoutContext();
  const isPayment = checkout.state === 'payment';
  let voucherArr: any = [];

  const cartModification = useCartModification();
  const customItemUpdate = useCallback(
    async (id: string, qty: number | string) => {
      await cartModification.updateCustomItem([{ id, quantity: Number(qty) }]).then(() => onCardRemoved());
    },
    [cartModification]
  );

  const removeGiftCard = () => {
    setRemovingCard(true);
    if(gcItem && gcItem.length > 0){
      customItemUpdate(gcItem[0].id, 0);
      setGiftCardApplied(false);      
    }
  }
  
  let gcItem = cart?.customLineItems.filter(item => item.name.en === 'RedeemVoucher');
  const gcApplied = gcItem?.length > 0 ? true : false;
  if(gcApplied !== giftCardApplied){
    setGiftCardApplied(gcApplied);
  }

  function isJsonString(errObj: readonly GraphQLError[] | Error | undefined) {
    try {
      const val = JSON.parse((errObj && errObj[0]?.message) || 'Something went wrong');
      if (val && typeof val === 'object') {
        return val;
      }
    } catch (e) {}
    return false;
  }
  const changeEventHandler = e => {
    setGiftCart(e.target.checked);
    if (!e.target.checked) {
      setGiftSec(e.target.checked);
    }
  };
  const onCardRemoved = () => {
    setRemovingCard(false);
    setGiftCart(true);
    notify({
      kind: 'success',
      title: intl.msg('title.productadded', 'Success!'),
      subtitle: 'Voucher removed successfully!'
    });
  };

  const onSuccess = () => {
    setGiftCart(false);
    notify({
      kind: 'success',
      title: intl.msg('title.productadded', 'Success!'),
      subtitle: 'Voucher redeemed successfully!!!'
    });
  };

  const onFailure = err => {
    const errObj: ErrorResponse = err;
    const errVals = isJsonString(errObj?.graphQLErrors || undefined);
    notify({
      kind: 'error',
      title: intl.msg('title.productadded', 'Oops! '),
      subtitle: errVals.message
    });
  };

  const handleGiftCard = () => {
    cartApi
      .addVoucher({
        name: 'RedeemVoucher',
        giftType: '',
        slug: GCNum + '**' + ACode,
        taxCategory: { typeId: '', id: '' },
        productPrice: 0,
        productCurrency: ''
      })
      .then(() => {
        if (parseFloat(cart?.shippingInfo?.shipMode?.shippingRate?.value!) == 0.00) {
          cartApi
            .setShippingMode(session?.virtualShipId, undefined, undefined, undefined)

            .then(onSuccess)

            .catch(onFailure);
        }
        else{
          console.log('abc')
        }        
      })
      .catch(onFailure);
  };
  const onSelectHandler = item => {
    if (item === 'new') {
      setGCNum('');
      setGiftSec(true);
      setACode('');
    } else {
      setGCNum(item);
      setGiftSec(true);
      const findData = voucherArr?.find(eachEle => eachEle?.slug.split('/')[0] === item);
      setACode(findData?.slug?.split('*****')[1]);
    }
  };

  const ValidateGCNum = val => {
    setGCNum(val);
  };

  const ValidateActCode = val => {
    if (val.toString().length != 6) {
      setErrMsg('Please enter a 6 digit activation code');
    } else {
      setErrMsg('');
    }
    setACode(val);
  };
  orders &&
    orders?.map(order => {
      if (order?.node?.customLineItems?.length) {
        const ci: any = order?.node?.customLineItems.filter(
          item => item.item.id === 'RedeemVoucher'
        );
        if (ci) {
          if (voucherArr.length) {
            voucherArr = [...voucherArr, ...ci];
          } else {
            voucherArr = [...ci];
          }
        }
      }
    });

  return (
    <>
      {addressShow && (shippingAddress || billingAddress) && (
        <S.Addresses>
          <LayoutSpacing size="sm" />
          {shippingAddress && shippingAddress.address1 && (
            <Address
              key="shipping"
              // title={intl.msg('title.shippingaddress', 'Shipping Address')}
              address={shippingAddress}
            />
          )}
          {billingAddress && billingAddress.address1 && (
            <Address
              key="billing"
              // title={intl.msg('title.billingaddress', 'Billing Address')}
              address={billingAddress}
            />
          )}
        </S.Addresses>
      )}
      {(isPayment || !addressShow) && (
        <>
          {isPayment && !addressShow && (
            <S.PromoRow>
              <PromoCode cart={cart} />
            </S.PromoRow>
          )}

          {!addressShow ? <CartSubtotal cart={cart} showDelivery={isPayment} /> : <></>}

          {isUser && isPayment && !addressShow && (
            <S.GiftRow>
              <S.PromoHeader>Gift Card</S.PromoHeader>
              {giftCardApplied && (
              <>
                <S.RemoveButton onClick={() => removeGiftCard()}><Button label={removingCard ? "Removing Card..." :"Click to remove the gift card"} className='input-button reedemBtn' /></S.RemoveButton>
                <p>Note: If you have updated the cart, please remove and add back the gift card to recalculate the discount amount.</p>
              </>)}
              <Checkbox
                labelText="Use gift card"
                id="giftSelect"
                className="input-checkbox"
                onChange={e => changeEventHandler(e)}
                disabled={giftCardApplied}
              />
              
              {isGiftCard ? (
                <S.GiftContainer>
                  <S.RegInfo>
                    Enter your Gift Card details and click <strong>Redeem</strong> to apply the Gift Card to your basket.
                  </S.RegInfo>
                  {!giftCardApplied && (
                    <Dropdown
                      id="redeemCode"
                      labelText="Please select a gift card"
                      items={
                        orders
                          ? _.uniq([
                              'new',
                              ...voucherArr.map(eachVoucher => eachVoucher?.slug.split('/')[0])
                            ])
                          : ['new']
                      }
                      onChange={selected => onSelectHandler(selected)}
                  />)}
                  {showGiftSec && !giftCardApplied ? (
                    <S.CardDetails>
                      <S.GATitle>Gift Card Number:</S.GATitle>
                      <NumberInput
                        className="input-field-GC"
                        id="GCNum"
                        value={GCNum}
                        onChange={e => ValidateGCNum(e.target.value)}
                      />
                      <S.GATitle>Activation Code:</S.GATitle>
                      <NumberInput
                        className="input-field-ACT"
                        id="Acode"
                        errorText={errMsg}
                        value={ACode}
                        onChange={e => ValidateActCode(e.target.value)}
                      />
                      <Button
                        data-testid="reedemCodeButton"
                        disabled={errMsg || !ACode || !GCNum}
                        variant="tertiary"
                        label={isMobile ? 'Redeem' : 'Redeem this card'}
                        className="input-button reedemBtn"
                        onClick={() => handleGiftCard()}
                      />
                    </S.CardDetails>
                  ) : (
                    <></>
                  )}
                </S.GiftContainer>
              ) : (
                <></>
              )}
            </S.GiftRow>
          )}
        </>
      )}
      {/* {!addressShow && <CartSummary cart={cart} />} */}

      {/* TODO: Find a way to make this work */}
      {/*
      <S.SubmitButton>      
        <Button disabled label="Almost done" />
      </S.SubmitButton>
      */}
      {/* {!addressShow && <LayoutSpacing size="xl" />} */}
    </>
  );
};
CheckoutSidebar.fragment = gql`
  fragment OrderHistoryContainer on CusMe {
    id
    zones
    orders {
      edges {
        node {
          id
          grandTotal {
            value
            currency
          }
          placedDate
          updateDate
          status
          statusCode
          shippingAddress {
            firstName
            lastName
            streetName
            additionalStreetInfo
            postalCode
            city
            region
            country
            phone
            email
            key
            trackingLink
          }
          lineItems {
            id
            linePrice {
              value
              currency
            }
            partnumber
            quantity
            item {
              name
              thumbnail
            }
          }
          customLineItems {
            id
            slug
            linePrice {
              value
              currency
            }
            partnumber
            quantity
            item {
              id
            }
          }
        }
      }
    }
  }
`;
CheckoutSidebar.Skeleton = () => <div>Loading...</div>;

type Props = CartContainerRenderProps & {
  shippingAddress?: any;
  billingAddress?: any;
  cart: Cart;
  addressShow?: boolean;
};
